import { useContext, useEffect, useState } from "react";
import { format } from "react-string-format";
import { useConfirm } from "material-ui-confirm";
import { Context } from "../../../utils/context";
import { Strings } from "../../../assets/res/en";
import {
  userEndPoints,
  groupsEndPoints,
  merchantsEndPoints,
  profilesEndPoints,
} from "../../../utils/endpoints";
import userDataColumn from "../../../dataColumns/userDataColumn";
import useTableIcons from "../../useTableIcons";
import useCommonMenus from "../common/useCommonMenus";
import { modules } from "../../../utils/config";

export default function useUsers() {
  const { axios, authData, permissions } = useContext(Context);
  const authToken = `Bearer ${authData.token}`;
  const [userPermission, setUserPermission] = useState({});
  const [users, setUsers] = useState([]);
  const [susers, setSearchUsers] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  const [groupsMenus, setGroupMenus] = useState([]);
  const [locationMenus, setLocationMenus] = useState([]);
  const [searchData, setSearchData] = useState({
    sUserName: "",
    sGroup: "",
    sLocation: "",
  });
  const [filters, setFilters] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [modalHeader, setModalHeader] = useState({});
  const [modalContent, setModalContent] = useState({});
  const [modalFormResetKeys, setModalFormResetKeys] = useState([]);
  const [modalActions, setModalActions] = useState([]);
  const [modalTaskRunning, setModalTaskRunning] = useState(false);
  const [modalFormError, setModalFormError] = useState({});
  const { columns, sytlingOptions } = userDataColumn();
  const { tableIcons } = useTableIcons();
  const { profileMenus, countryCodeMenus } = useCommonMenus(axios);
  const confirm = useConfirm();

  useEffect(() => {
    console.log(phoneNumber)
  }, [phoneNumber])
  //check permission changes
  useEffect(() => {
    if (permissions && permissions.length > 0) {
      let usrPermission = permissions.find(
        (p) => p.moduleId === modules.users.id
      );
      setUserPermission(usrPermission);
    }
  }, [permissions]);
  //get Groups
  useEffect(() => {
    axios
      .get(groupsEndPoints.getAll, { headers: { Authorization: authToken } })
      .then((res) => {
        if (res.data.success) {
          const { data } = res.data;
          const groupItems = data
            .map((g) => ({
              text: g.description,
              val: g.idGroup,
            }))
            .sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""));
          setGroupMenus([
            {
              text: Strings.SEARCH_CASINO_GROUP,
              val: "",
            },
            {
              text: Strings.NO_GROUP,
              val: 0,
            },
            ...groupItems,
          ]);
        }
      })
      .catch((err) => err);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //get Locations On Group Chnage
  useEffect(() => {
    setLocationMenus([
      {
        text: Strings.SEARCH_CASINO_LOCATION,
        val: "",
      },
      {
        text: Strings.NO_LOCATION,
        val: 0,
      },
    ]);
    setSearchData((prevData) => ({
      ...prevData,
      sLocation: "",
    }));
    if (searchData.sGroup > 0) {
      let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${searchData.sGroup}`;
      axios
        .get(merchantByGroupId, { headers: { Authorization: authToken } })
        .then((res) => {
          if (res.status === 200) {
            const { data } = res.data;
            const locationItems = data
              .map((g) => ({
                text: g.description,
                val: g.idMerchant,
              }))
              .sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""));
            setLocationMenus((prevData) => [...prevData, ...locationItems]);
          }
        })
        .catch((err) => err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData.sGroup]);

  const clearFilter = ({ name }, nfilters, searchData) => {
    let filteredData = susers;
    //#region filter data
    switch (name) {
      case "sUserName":
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          filteredData = filteredData.filter(
            (u) => u.idGroup === searchData["sGroup"]
          );
        if (searchData["sLocation"] !== "" && searchData["sLocation"] >= 0)
          filteredData = filteredData.filter(
            (u) => u.idMerchant === searchData["sLocation"]
          );
        break;
      case "sGroup":
        if (searchData["sUserName"] && searchData["sUserName"].trim() !== "")
          filteredData = filteredData.filter((u) =>
            u.name
              .toLowerCase()
              .includes(searchData["sUserName"].trim().toLowerCase())
          );
        const finr = nfilters.filter(
          (f) => f.name !== "sGroup" || f.name !== "sLocation"
        );
        const fir = nfilters.find((f) => f.name === "sLocation");
        fir.value = "";
        setFilters([fir, ...finr]);
        setSearchData((prevData) => ({
          ...prevData,
          sLocation: "",
        }));
        break;
      case "sLocation":
        if (searchData["sUserName"] && searchData["sUserName"].trim() !== "")
          filteredData = filteredData.filter((u) =>
            u.name
              .toLowerCase()
              .includes(searchData["sUserName"].trim().toLowerCase())
          );
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          filteredData = filteredData.filter(
            (u) => u.idGroup === searchData["sGroup"]
          );
        break;
      default:
        break;
    }
    //#endregion

    //#region clear filter
    const filterItemNotToRemove = nfilters.filter((f) => f.name !== name);
    const filterItemToRemove = nfilters.find((f) => f.name === name);
    filterItemToRemove.value = "";
    setFilters([filterItemToRemove, ...filterItemNotToRemove]);
    //#endregion

    setSearchData((prevData) => ({
      ...prevData,
      [name]: "",
    }));
    setUsers(filteredData);
  };
  const resetFilterData = (nfilters) => {
    setFilters(nfilters.map((item) => ({ ...item, value: "" })));
    setSearchData({
      sUserName: "",
      sGroup: "",
      sLocation: "",
    });
    getAllUsers();
  };
  const handleChange = (name, value) => {
    setSearchData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSearch = () => {
    setFilters([
      {
        name: "sUserName",
        value: searchData["sUserName"],
        remove: clearFilter,
      },
      {
        name: "sGroup",
        value:
          searchData["sGroup"] === ""
            ? ""
            : groupsMenus.find((g) => g.val === searchData["sGroup"]).text,
        remove: clearFilter,
      },
      {
        name: "sLocation",
        value:
          searchData["sLocation"] === ""
            ? ""
            : locationMenus.find((l) => l.val === searchData["sLocation"]).text,
        remove: clearFilter,
      },
      {
        name: "clear",
        isClearAll: true,
        clearAll: resetFilterData,
      },
    ]);
    let filteredData = susers;
    if (
      searchData["sUserName"].trim() === "" &&
      (searchData["sGroup"] === "" || searchData["sGroup"] < 0) &&
      (searchData["sLocation"] === "" || searchData["sLocation"] < 0)
    )
      resetFilterData(filters);
    else {
      if (searchData["sUserName"] && searchData["sUserName"].trim() !== "")
        filteredData = filteredData.filter((u) =>
          u.name
            .toLowerCase()
            .includes(searchData["sUserName"].trim().toLowerCase())
        );
      if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
        filteredData = filteredData.filter(
          (u) => u.idGroup === searchData["sGroup"]
        );
      if (searchData["sLocation"] !== "" && searchData["sLocation"] >= 0)
        filteredData = filteredData.filter(
          (u) => u.idMerchant === searchData["sLocation"]
        );
      setUsers(filteredData);
    }
  };

  const searchOptions = {
    title: Strings.SEARCH_USER_TILTLE,
    spacing: 2,
    searchItems: [
      {
        name: "sUserName",
        label: Strings.COLUMN_USER_NAME,
        type: "search",
        defaultValue: searchData["sUserName"],
        onChange: handleChange,
      },
      {
        name: "sGroup",
        label: Strings.SEARCH_CASINO_GROUP,
        isSelect: true,
        menuItems: groupsMenus,
        defaultValue: searchData["sGroup"],
        onChange: handleChange,
      },
      {
        name: "sLocation",
        label: Strings.SEARCH_CASINO_LOCATION,
        isSelect: true,
        menuItems: locationMenus,
        defaultValue: searchData["sLocation"],
        onChange: handleChange,
      },
    ],
    handleSearch,
  };

  const getAllUsers = () => {
    setIsLoading(true);
    axios
      .get(userEndPoints.getAll, { headers: { Authorization: authToken } })
      .then((res) => {
        if (res.data.success) {
          const { data } = res.data;
          setUsers(data);
          setSearchUsers(data);
        }
      })
      .catch((err) => err)
      .finally(() => setIsLoading(false));
  };
  const actions = [
    (rowData) => ({
      icon:
        rowData.status === 0 ? tableIcons.CheckBoxBlank : tableIcons.CheckBox,
      tooltip: userPermission.update
        ? rowData.status === 0
          ? "Activate this User"
          : "Deactivate this User"
        : "Permission Denied",
      disabled: !userPermission.update,
      onClick: (event, rowData) =>
        new Promise((resolve) => {
          let cnfDesc =
            rowData.status === 0
              ? `This will activate user ${rowData.name}`
              : `This will deactivate user ${rowData.name}`;
          confirm({ description: cnfDesc }).then(() => {
            let url =
              rowData.status === 0
                ? userEndPoints.activateUserById
                : userEndPoints.deActivateUserById;
            axios
              .put(
                format(url, rowData.idUser),
                {},
                { headers: { Authorization: authToken } }
              )
              .then((res) => {
                if (res.data.success) {
                  const dataUpdate = [...users];
                  const index = rowData.tableData.id;
                  dataUpdate[index] = res.data.data;
                  setUsers([...dataUpdate]);
                  resolve();
                }
              });
          });
        }),
    }),
    {
      icon: tableIcons.Edit,
      tooltip: userPermission.update ? "Edit User" : "Permission Denied",
      disabled: !userPermission.update,
      onClick: (event, rowData) =>
        new Promise((resolve) => {
          handleActionClick(event, true, rowData);
          resolve();
        }),
    },
  ];
  //#region Modal
  // Regla compartida de contraseña: mínimo 8 caracteres, con al menos una letra
  // y al menos un número. Se usa tanto al crear (campos siempre visibles) como
  // al editar (campos que aparecen con el toggle "Change Password").
  const passwordValidator = {
    required: { value: true, message: "Password is required" },
    minLength: {
      value: 8,
      message: "Password must have at least 8 characters",
    },
    pattern: {
      value: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
      message:
        "Password must be at least 8 characters and include letters and numbers",
    },
  };
  const handleSubmit = async(data, isEdit, idUser, _phoneNumber) => {
    
    const completePhoneNumber = data.countryCodeId + data.phoneNumber
    delete data.phoneNumber
    delete data.countryCodeId
    setModalTaskRunning(true);

    let user_id = null
    
    let url =
      isEdit === true
        ? format(userEndPoints.updateUser, idUser)
        : userEndPoints.postUser;

    try{
      const response = await axios({
        method: isEdit === true ? "put" : "post",
        url: url,
        headers: { Authorization: authToken },
        data: data,
      })
  
      if (response.status === 200) {
        user_id = response.data.data.idUser
        //handleModalClose();
        //getAllUsers();
      } else {
        setModalFormError(response.errors)
        setModalTaskRunning(false)
        return
      };
    }catch(e){
      console.log(e)
      setModalTaskRunning(false)
    }

    let urlPhone;
    let data2send;
    try {
      if(completePhoneNumber){
        const phoneaction = (_phoneNumber !== null && _phoneNumber !== undefined)
        urlPhone =
        phoneaction === true
          ? format(userEndPoints.updatePhone, user_id, _phoneNumber.idPhone)
          : format(userEndPoints.postPhone, user_id);

        if(phoneaction){ // update
          data2send = {..._phoneNumber, phoneNumber: completePhoneNumber}
        }else{
          data2send = {
            idPhoneType: 2,
            phoneNumber: completePhoneNumber,
            preferred:true
          }
        }
        if(phoneaction){ // PUT
          await axios.put(urlPhone, data2send, { headers: { Authorization: authToken } })
        }else{ // POST
          await axios.post(urlPhone, data2send, { headers: { Authorization: authToken } })
        }
      }
      
    } catch (error) {
      console.log(error)
    }

    handleModalClose();
    getAllUsers()
    setModalTaskRunning(false)
    
  };
  const onAddEditPhoneNumber = async() => {

  };
  const handleSelectionChange = (event) => {
    axios
      .get(format(profilesEndPoints.getProfileById, event.target.value), {
        headers: { Authorization: authToken },
      })
      .then((res) => {
        if (res.data.success) {
          const { groupDescription, merchantDescription } = res.data.data;
          new Promise((resolve) => {
            setModalFormResetKeys(["Group", "Location"]);
            resolve();
          }).then(() =>
            setModalContent((prevContent) => ({
              ...prevContent,
              Group: {
                ...prevContent["Group"],
                value: groupDescription ?? Strings.NO_GROUP,
              },
              Location: {
                ...prevContent["Location"],
                value: merchantDescription ?? Strings.NO_LOCATION,
              },
            }))
          );
        }
      })
      .catch((err) => err);
  };
  const handleModalClose = () => {
    setOpenDialog(false);
    setModalFormError({});
    setModalFormResetKeys([]);
  };
  const handleActionClick = async (event, isEdit = false, rowData = {}) => {
    
    let phonenumber = ''
    let phoneCountryCode = '1'
    let phoneObj = null
    console.log('ID user', rowData.idUser)
    if(rowData.idUser){
      try {
        const phonerequest = await axios.get(
          format(userEndPoints.getPhone, rowData.idUser), 
          { headers: { Authorization: authToken }}
        )
        const _phonedata = phonerequest.data.data
        if(_phonedata.constructor === Array && _phonedata.length > 0){
          //console.log('Save phonenumber', _phonedata[0])
          phoneObj = _phonedata[0]
          phonenumber = phoneObj.phoneNumber
          console.log(typeof phonenumber)
          if(typeof phonenumber === "string"){
            let aux = phonenumber
            if(!aux.includes("+")){
              aux = `+${aux}`
            }
            // Checkout country code
            for(let i=0; i<countryCodeMenus.length;i++){
              let currentCode = countryCodeMenus[i]
              const result = aux.split(currentCode.text)
              if(result.length === 2){
                phonenumber = result[1]
                phoneCountryCode = currentCode.val
              } 
            }
          }
          console.log('Country code', phoneCountryCode, 'Phone number ', phonenumber)
        }
      } catch (error) {
        console.log(error)
      }
      setPhoneNumber(phoneObj)
    }
    

    setModalHeader({
      isForm: true,
      title: isEdit === true ? "Edit User" : "Add User",
      header: isEdit === true ? "Edit this existing User" : "Create a new User",
    });
    const modalContentObj = {
      Name: {
        label: "User Name",
        size: "small",
        variant: "outlined",
        col: 12,
        value: rowData.name ?? "",
        validator: {
          required: { value: true, message: "Username is required" },
        },
      },
      Email: {
        label: "Email",
        size: "small",
        variant: "outlined",
        col: 12,
        value: rowData.email ?? "",
        disabled: isEdit === true,
        validator: {
          required: { value: true, message: "Email is required" },
          pattern: {
            value: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/i,
            message: "Email is invalid",
          },
        },
      },
      countryCodeId: {
        label: "Code",
        size: "small",
        type: "select",
        variant: "outlined",
        col: 3,
        value: phoneCountryCode ?? "+1",
        menuItems: countryCodeMenus,
        validator: {
          required: { value: true, message: "Please choose a country code" },
        },
        onSelectionChange: handleSelectionChange,
      },
      phoneNumber: {
        label: "Mobile",
        size: "small",
        variant: "outlined",
        col: 9,
        value: phonenumber ?? "",
        validator: {
          required: { value: true, message: "Phone is required" },
          pattern: {
            value: /^(?:[0-9] ?){6,14}[0-9]$/i,
            message: "Phone is invalid",
          },
        },
      },
      IdProfile: {
        label: "Profile",
        type: "select",
        size: "small",
        variant: "outlined",
        col: 12,
        value: rowData.idProfile ?? "",
        menuItems: profileMenus,
        validator: {
          required: { value: true, message: "Please choose a Profile" },
        },
        onSelectionChange: handleSelectionChange,
      },
      Group: {
        label: "Group",
        size: "small",
        variant: "outlined",
        col: 6,
        disabled: true,
        value: rowData.groupDescription ?? Strings.NO_GROUP,
      },
      Location: {
        label: "Location",
        size: "small",
        variant: "outlined",
        col: 6,
        disabled: true,
        value: rowData.merchantDescription ?? Strings.NO_LOCATION,
      },
    };

    // Al EDITAR se conserva el toggle "Change Password": la contraseña es
    // opcional y sus campos aparecen solo si se activa el switch.
    // Al CREAR la contraseña es obligatoria, así que los campos van SIEMPRE
    // visibles (sin toggle).
    if (isEdit === true) {
      modalContentObj.ChangePassword = {
        label: "Change Password",
        size: "small",
        variant: "outlined",
        col: 12,
        disabled: false,
        type: "switch",
        value: false,
        onSwitchChange: handleSwitchChange,
      };
    } else {
      modalContentObj.Password = {
        label: "Password",
        size: "small",
        variant: "outlined",
        col: 6,
        disabled: false,
        type: "password",
        value: "",
        validator: passwordValidator,
        showPassword: false,
        setShowPassword: handShowPassword,
      };
      modalContentObj.ConfirmPassword = {
        label: "Confirm password",
        size: "small",
        variant: "outlined",
        col: 6,
        disabled: false,
        type: "password",
        match: {
          field: "Password",
          errorMsg: "Password and Confirm Password must match",
        },
        value: "",
        showPassword: false,
        setShowPassword: handShowConfirmPassword,
      };
    }

    setModalContent(modalContentObj);

    setModalActions([
      {
        label: isEdit === true ? "Update" : "Save",
        icon: isEdit === true ? tableIcons.Edit : tableIcons.Save,
        isSubmit: true,
        action:
          isEdit === true
            ? (data) => handleSubmit(data, true, rowData.idUser, phoneObj)
            : (data) => handleSubmit(data, false),
      },
    ]);
    setOpenDialog(true);
  };

  const handleSwitchChange = (event) => {
    if (event.target?.checked) {
      setModalContent((prevContent) => ({
        ...prevContent,
        Password: {
          label: "Password",
          size: "small",
          variant: "outlined",
          col: 6,
          disabled: false,
          type: "password",
          value: "",
          validator: passwordValidator,
          showPassword: false,
          setShowPassword: handShowPassword,
        },
        ConfirmPassword: {
          label: "Confirm password",
          size: "small",
          variant: "outlined",
          col: 6,
          disabled: false,
          type: "password",
          match: {
            field: "Password",
            errorMsg: "Password and Confirm Password must match",
          },
          value: "",
          showPassword: false,
          setShowPassword: handShowConfirmPassword,
        },
      }));
    } else {
      setModalContent((prevContent) => {
        const { Password, ConfirmPassword, ...reset } = prevContent;
        return reset;
      });
    }
  };
  const handShowPassword = (value) => {
    setModalContent((prevContent) => ({
      ...prevContent,
      Password: {
        ...prevContent["Password"],
        showPassword: !prevContent["Password"].showPassword,
        value: value,
      },
    }));
  };
  const handShowConfirmPassword = (value) => {
    setModalContent((prevContent) => ({
      ...prevContent,
      ConfirmPassword: {
        ...prevContent["ConfirmPassword"],
        showPassword: !prevContent["ConfirmPassword"].showPassword,
        value: value,
      },
    }));
  };

  //#endregion

  return {
    users,
    isLoading,
    getAllUsers,
    searchOptions,
    columns,
    sytlingOptions,
    actions,
    filters,
    searchData,
    openDialog,
    handleModalClose,
    handleActionClick,
    modalHeader,
    modalContent,
    modalActions,
    modalFormResetKeys,
    modalTaskRunning,
    modalFormError,
    userPermission,
  };
}
